// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-Project-Settings-Dashboards-ModalEditDashboardLayout-___styles__toggleBtn {
  width: 100px !important;
  border: none !important;
  font-size: 14px !important;
  text-transform: initial !important;
  font-weight: bold !important;
  color: var(--colors-greyDark) !important;
}
`, "",{"version":3,"sources":["webpack://./app/pages/Project/Settings/Dashboards/ModalEditDashboardLayout/styles.scss"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,0BAA0B;EAC1B,kCAAkC;EAClC,4BAA4B;EAC5B,wCAAwC;AAC1C","sourcesContent":[".toggleBtn {\n  width: 100px !important;\n  border: none !important;\n  font-size: 14px !important;\n  text-transform: initial !important;\n  font-weight: bold !important;\n  color: var(--colors-greyDark) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toggleBtn": `app-pages-Project-Settings-Dashboards-ModalEditDashboardLayout-___styles__toggleBtn`
};
export default ___CSS_LOADER_EXPORT___;
